import React, { useState, useEffect } from "react";
import Common_Title from "../../common/common-title/Common_Title";
import "./Guidance_Service.css";
import Start_Btn from "../../common/start-btn/Start_Btn";
import { useDispatch, useSelector } from "react-redux";
import { GetAllOurGuidance } from "../../../features/components/homepage/ourguidance/Slice";
import { IDS } from "../../../utils/IDS";
import Fill_Form_Modal from "../../modals/fill-form-modal/Fill_Form_Modal";

const Guidance_Service = () => {
  const careerData = [
    {
      id: 1,
      image: "/assets/images/home/Guidance_Service/img-1.png",
      title: "Online Career Assessment",
      desc:
        "MCQ-based aptitude, personality, and interest tests with automated scoring and expert analysis to identify suitable career paths.",
      btn: "Start Test",
      link: "/book-a-session",
    },
    {
      id: 2,
      image: "/assets/images/home/Guidance_Service/img-2.png",
      title: "Career Counselling",
      desc:
        "One-to-one counselling sessions with expert counsellors to review assessment results & recommend suitable streams, courses, and colleges.",
      btn: "Explore",
      link: "/career-counselling",
    },

    {
      id: 3,
      image: "/assets/images/home/Guidance_Service/img-3.png",
      title: "Motivational Workshops",
      desc:
        "Interactive sessions designed to build clarity, confidence, and goal-oriented thinking among students.",
      btn: "Book Session",
      link: "/book-a-session",
    },

    {
      id: 4,
      image: "/assets/images/home/Guidance_Service/img-4.png",
      title: "Parent Counselling",
      desc:
        "Dedicated counselling support to help parents Understand their child and Career options, streams, and informed decision-making for their children. ",
      btn: "Explore",
      link: "/parental-counselling",
    },
  ];

  const dispatch = useDispatch();
  const ourguidance = useSelector(
    (state) => state?.homepage?.ourguidance?.all_ourguidance,
  );

  // console.log(ourguidance, "Our Guidance");

  useEffect(() => {
    dispatch(GetAllOurGuidance());
  }, [dispatch]);

  const [showModal, setShowModal] = useState(false);

  return (
    <section className="Guidance_Service">
      <div className="container">
        <Common_Title title="Our Guidance Services" />

        <div className="career_options">
          <div className="row">
            {ourguidance?.map((item) => (
              <div className="col-lg-6 col-md-6 mb-5" key={item?.id}>
                <div className="career_card">
                  <div className="career_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item?.title}
                      className="career_img"
                    />
                  </div>
                  <div className="career_content">
                    <h4 className="career_title">{item?.name}</h4>
                    <p className="career_desc">
                      {item?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
                    </p>
                    {item?.button == "Start Test" ? (
                      <Start_Btn
                        text={item?.button}
                        link={"/test-instructions"}
                      />
                    ) : item?.button == "Explore Career" ? (
                      <Start_Btn
                        text={item?.button}
                        link={"/career-counselling"}
                      />
                    ) : item?.button == "Explore Parent " ? (
                      <Start_Btn
                        text={item?.button}
                        link={"/parental-counselling"}
                      />
                    ) : (
                      <Start_Btn
                        text={item?.button}
                        onClick={() => setShowModal(true)}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Fill_Form_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </section>
  );
};

export default Guidance_Service;
